class ProductRecommendations extends HTMLElement {
    constructor() {
        super()
    }
    connectedCallback() {
        this.block = this.closest('[data-block-type="complementary-products"]'), 
        this.container = this.querySelector("[data-products-container]"), 
        this.intent = this.dataset.intent, 
        this.max_products = this.getAttribute("data-max-products"), 
        this.product_id = this.getAttribute("data-product-id"), 
        this.load()
    }
    async load() {
        //gets promise from product_recommendations url (of the file related-products.liquid and all refered to within) with the set intent, max products, based on product id
        var t = await fetch(`${theme.urls.product_recommendations}?section_id=${this.intent}-products&limit=${this.max_products}&product_id=${this.product_id}&intent=` + this.intent);
        if (!t.ok) throw new Error(t.statusText);
        var e = await t.text(),
            o = theme.utils.parseHtml(e).querySelectorAll("[data-product-item]"); //extracts the data-product-items from the fetched data text
        if (o.length) {
            const s = new DocumentFragment;
            o.forEach(t => s.append(t)), //populates the fragment with the data-product-items
            this.container.appendChild(s), //attaches the fragment to data-products-container
            this.style.display = "block"  //shows product recommendations
        } else 
          this.block && 
          (this.block.style.display = "none");
        if (typeof globoswatch !== 'undefined') {
          globoswatch.init();
        }
        
    }
}
const productRecommendationsEl = customElements.get("product-recommendations-root");
productRecommendationsEl || customElements.define("product-recommendations-root", ProductRecommendations);